import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";

import img1 from "../img/bgsimg (1).jpeg";
import img2 from "../img/bgsimg (2).jpeg";
import img3 from "../img/bgsimg (3).jpeg";
import img4 from "../img/bgsimg (4).jpeg";
import img5 from "../img/bgsimg (5).jpeg";
import img6 from "../img/bgsimg (6).jpeg";
import img7 from "../img/bgsimg (7).jpeg";
import img8 from "../img/bgsimg (8).jpeg";

// Create an array of imported images
const images = [
  { image: img1, title: " 1" },
  { image: img2, title: " 2" },
  { image: img3, title: " 3" },
  { image: img4, title: " 4" },
  { image: img5, title: " 5" },
  { image: img6, title: " 6" },
  { image: img7, title: " 7" },
  { image: img8, title: " 8" },
];
export default function About() {
  const state = useSelector((state) => state);

  const [size, setSize] = useState("contain");
  const [position, setPosition] = useState("top");

  useEffect(() => {
    setInterval(() => {
      setSize("cover");
      setPosition("center");
    }, 500);
  }, []);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            backgroundSize: size,
            backgroundPosition: position,
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/bgs2.jpg") +
              "')",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "26px" : "40px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              textAlign: "center",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            About BGS WORLD SCHOOL
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "100px" }}>
          <div
            style={{
              fontSize: state.auth.isMobile ? "16px" : "20px",
              fontFamily: "Montserrat",
              textAlign: "justify",
            }}
          >
            <b> Welcome to BGS World School</b> <br /> <br /> 1. The location of
            a school has an enormous significance; our school is far away from
            the noises and the pollution. The ambience is calm, spacious with
            good amenities and utilities in a visually appealing landscape.{" "}
            <br /> <br /> 2. The backbone of any school’s infrastructure is the
            classroom. We have adequate classrooms which are pleasant with
            modern learning experience.
            <br /> <br /> 3. Enriching young minds with value based Education.
            We strive to offer true education that teaches and imbibes universal
            values and morals, builds courage, instills self-confidence, and
            fosters a sense of responsibility in the children. <br /> <br />
            4. A competent teacher plays a vital role in the growth of the
            child. Our teachers are highly qualified, value-driven, passionate
            and experienced. <br /> <br />
            5. The events and activities are part of the curriculum which aims
            at instilling discipline, ethics and values in students that would
            help them to develop their personality to become better citizens of
            the world.
          </div>
        </div>
        <div className="aboutabout2" style={{ marginTop: "-150px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} md={5}>
              <img
                style={{ width: "100%", objectFit: "cover", margin: "10px" }}
                src={require("../img/bgsimg (13).jpeg")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Our Vision
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "20px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  marginBottom: "50px",
                }}
              >
                We envision a future where our students are equipped with the
                skills, values, and commitment to serve, thrive in an
                ever-evolving, interconnected world, and create a brighter
                tomorrow for themselves and their community.
              </div>
              <br />

              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Our Mission
              </div>
              <br />

              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "20px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our mission is to Empower young minds to flourish in the 21st
                century to foster community of curious, compassionate and
                courageous leaders. We integrate academic excellence with
                Spiritual growth, Sanskaras, Social responsibility, develop
                effective communication, and inspiring to become enlightened
                global citizens.
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-150px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                  marginTop: state.auth.isMobile ? "-50px" : "50px",
                }}
              >
                About Principal
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "16px" : "22px",

                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                With over 14 years of experience navigating diverse curricula
                across various states, Mrs. Suma Konduru possesses a profound
                and nuanced understanding of the educational landscape. Her
                multidisciplinary expertise enables her to foster a holistic
                learning environment that nurtures academic excellence,
                emotional resilience, and social responsibility. As a visionary
                educator and compassionate leader, Mrs. Suma Konduru is
                dedicated to empowering students, teachers, and the broader
                school community. Her unwavering commitment to excellence,
                inclusivity, and innovation has created a vibrant and supportive
                school ecosystem, where every individual can thrive, grow, and
                reach their full potential."
                <br />
                <br />
                <b>Mrs. Suma Konduru</b>
                <br />
                Principal, BGS World School
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                style={{
                  width: "100%",
                  objectFit: "cover",
                  margin: "10px",
                  height: "60%",
                }}
                src={require("../img/asdds.jpeg")}
              />
            </Grid>
          </Grid>
        </div>
        <div className="news">
          <div
            style={{
              textAlign: "center",
              marginBottom: "50px",
              marginTop: state.auth.isMobile ? "-150px" : "-350px",
              fontSize: state.auth.isMobile ? "30px" : "40px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryColor
                  : themeStyle.primaryColor,
            }}
          >
            A Glimpse of the Campus
          </div>
          <Grid container spacing={2.5} style={{ marginBottom: "100px" }}>
            {images.map((gal, index) => (
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3} key={index}>
                <div className="icard">
                  <img
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                    src={gal.image} // Use the imported image directly
                    alt={gal.title}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
